var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.brandBar,on:{"click":_vm.onBrandBarClick}})}
var staticRenderFns = []

export { render, staticRenderFns }